import { Inspector, Skeleton, Box } from '@sequencehq/core-components'
import { GreyGrey30 } from '@sequencehq/core-components'
import { useBillingScheduleAggregate } from 'modules/BillingScheduleHome/utils/useBillingScheduleAggregate'
import { useBillingScheduleId } from 'modules/BillingScheduleHome/utils/useBillingScheduleId'
import { BillingScheduleAttachmentsInspectorItem } from './items/BillingScheduleAttachmentsInspectorItem'
import fill from 'lodash/fill'
import { BillingScheduleStripeSettingsInspectorItem } from './items/BillingScheduleStripeSettingsInspectorItem'
import { BillingScheduleGoCardlessSettingsInspectorItem } from './items/BillingScheduleGoCardlessSettingsInspectorItem'
import { BillingScheduleSalesforceInspectorItem } from './items/BillingScheduleSalesforceInspectorItem'
import { BillingScheduleNetsuiteInspectorItem } from './items/BillingScheduleNetsuiteInspectorItem'
import { useAtomValue } from 'jotai'
import { showAttachmentInInspectorAtom } from 'Assets/Attachments'
import { ActivityLogsInspectorItem } from 'ActivityLogs/index'

const useBillingScheduleHomeInspector = () => {
  const billingScheduleId = useBillingScheduleId()
  const billingScheduleAggregateQuery = useBillingScheduleAggregate({
    billingScheduleId,
    select: data => {
      return {
        customerId: data.billingSchedule.customerId,
        createdAt: data.billingSchedule.createdAt
      }
    }
  })

  return {
    isLoading: billingScheduleAggregateQuery.isPending,
    customerId: billingScheduleAggregateQuery.data?.customerId,
    billingScheduleId,
    billingScheduleCreatedAt: billingScheduleAggregateQuery.data?.createdAt
  }
}

const InspectorSkeleton = () => {
  return (
    <Box
      gridArea="inspector"
      borderLeft={`1px solid ${GreyGrey30}`}
      display="flex"
      flexDirection="column"
      alignItems="center"
      padding="8px"
      gap="2px"
      height="100%"
    >
      {fill(Array(3), null).map((_, idx) => (
        <Skeleton height="32px" width="32px" key={idx} />
      ))}
    </Box>
  )
}

const ATTACHMENTS_ITEM_ID = 'attachments.inspector.item'
export const BillingScheduleHomeInspector = () => {
  const hook = useBillingScheduleHomeInspector()
  const attachmentToView = useAtomValue(showAttachmentInInspectorAtom)

  if (hook.isLoading) {
    return <InspectorSkeleton />
  }

  return (
    <Inspector
      expanded={attachmentToView ? true : undefined}
      showItemId={attachmentToView ? ATTACHMENTS_ITEM_ID : undefined}
    >
      <Inspector.ItemGroup>
        <BillingScheduleAttachmentsInspectorItem
          billingScheduleId={hook.billingScheduleId}
          id={ATTACHMENTS_ITEM_ID}
        />
        <ActivityLogsInspectorItem
          entityId={hook.billingScheduleId}
          entityType="BILLING_SCHEDULE"
          enabled
        />
        <BillingScheduleNetsuiteInspectorItem
          billingScheduleId={hook.billingScheduleId}
        />
        <BillingScheduleStripeSettingsInspectorItem
          billingScheduleId={hook.billingScheduleId}
        />
        <BillingScheduleGoCardlessSettingsInspectorItem
          billingScheduleId={hook.billingScheduleId}
        />
        <BillingScheduleSalesforceInspectorItem
          billingScheduleId={hook.billingScheduleId}
        />
      </Inspector.ItemGroup>
    </Inspector>
  )
}
